var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUmbrella03Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 21.9593L12 12M17 3.33977C12.6868 0.849552 7.28964 1.93765 4.246 5.68296C3.94893 6.04852 3.80039 6.2313 3.75718 6.49318C3.7228 6.70154 3.77373 6.97767 3.88018 7.16006C4.01398 7.38929 4.25111 7.5262 4.72539 7.80002L19.2746 16.2C19.7489 16.4738 19.986 16.6108 20.2514 16.612C20.4626 16.613 20.7272 16.519 20.8905 16.3851C21.0957 16.2167 21.1797 15.9967 21.3477 15.5567C23.0695 11.0481 21.3132 5.82998 17 3.33977ZM17 3.33977C15.0868 2.2352 11.2973 5.2171 8.5359 10M17 3.33977C18.9132 4.44434 18.2255 9.2171 15.4641 14M22 22H2",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella03Icon);
export default __webpack_public_path__ + "static/media/umbrella-03_icon.e4346b12c195a48d03b94d63dd5594e2.svg";
export { ForwardRef as ReactComponent };